import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Image from '../../Image';

export function ProfileCard(props) {
  const {
    profileCharacter,
    profileUp,
  } = props;

  if (profileCharacter == null) {
    return null;
  }

  const {
    avatarImage,
    currentDomicile,
  } = profileCharacter;

  const icon = profileUp ? avatarImage : currentDomicile.image;
  const iconType = profileUp ? 'cameo' : 'lodgings';
  const tooltipData = profileUp ? null : { ...currentDomicile, image: null };

  return (
    <Image
      className="media__object profile__card"
      icon={icon}
      alt="You"
      type={iconType}
      border={false}
      tooltipData={tooltipData}
      tooltipPos="bottom"
      defaultCursor
    />
  );
}

ProfileCard.displayName = 'ProfileCard';

ProfileCard.propTypes = {
  profileCharacter: PropTypes.shape({}).isRequired,
  profileUp: PropTypes.bool,
};

ProfileCard.defaultProps = {
  profileUp: false,
};

const mapStateToProps = ({ profile: { profileCharacter } }) => ({ profileCharacter });

export default connect(mapStateToProps)(ProfileCard);
